import React from "react";
import Typography from "./Typography";
interface ISectionProps {
	title: string;
	children: React.ReactNode;
	className?: string;
}
const Section = (props: ISectionProps) => {
	return (
		<div className={`section  ${props.className ?? ""}`}>
			<div className="section_header">
				<Typography type="heading">{props.title}</Typography>
			</div>
			<div className="section_body">{props.children}</div>
		</div>
	);
};

Section.displayName = "Section";
export default Section;
